// Pixel widths for each Avatar size, sourced from avatar-components AVATAR_SIZES.
// Used as flex-basis for the avatar column so the layout adapts to the chosen size.
// 'responsive' falls back to the 'xs' width since it has no fixed pixel value.
export const AVATAR_SIZE_PX = {
  xxs: 16,
  xs: 24,
  sm: 32,
  md: 48,
  lg: 72,
  xl: 108,
  responsive: 24
};